/**
 * KWA 页左/右列设置 id 顺序，与 Figma 及 RBP2 一致；与首屏骨架行数同步。
 */
export const KWA_CORE_SETTING_KEYS = [17, 16, 44, 61] as const;
export const KWA_RUNTIME_SETTING_KEYS = [127, 128, 76, 104] as const;
